"use client"
import { useLocale } from 'next-intl'
import { usePathname } from 'next/navigation'
import Link from 'next/link'

export default function LanguageSwitcher() {
  const locale = useLocale()
  const pathname = usePathname()
  const other = locale === 'fr' ? 'es' : 'fr'
  const href = `/${other}${pathname?.replace(/^\/(fr|es)/, '') || ''}`
  return (
    <Link
      prefetch
      href={href}
      aria-label={`Switch language to ${other.toUpperCase()}`}
      className="rounded-md border border-gray-700 bg-transparent px-3 py-1 text-sm text-gray-100 transition-colors hover:border-gray-600 hover:bg-gray-800 hover:text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
    >
      {other.toUpperCase()}
    </Link>
  )
}

